import { Inject, Injectable, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Router } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import {SESSION_STORAGE, WebStorageService} from 'angular-webstorage-service';
import { environment } from '../../environments/environment';
import { NetworkingService } from './networking.service';
import { AgencyInfo, AgencyList } from './agency.model';
import { AgentInfo, AgentList } from './agent.model';
import { ThreeDecimalCurrencies } from'./globalConfig';
import { LoaderService } from './loader/loader.service';

@Injectable()
export class SharedService implements OnInit{
  public isloggedIn: boolean = false;
  public userRole: string;
  public redirectUrl: string = '/';
  //public loginUrl: string = '/login';
  public navMenu: boolean;
  public currentPageName: string;
  public currentPageSubject = new Subject<string>();
  currentPage$ = this.currentPageSubject.asObservable();
  public showAgencyInformation: boolean;	
  public agencyInfo : AgencyInfo;
  public agentInfo : AgentInfo;
  private userDetails : Object;
  private agentListSubject = new Subject<AgencyInfo>();
  agentList$ = this.agentListSubject.asObservable();
  public reportsMenu : Array <Object>;  
  public agencyDetails : Object;
  public authenticationToken : string;
  public hasModify : boolean = false;
  public hasTopup : boolean = false;
  public cityStoredObj:any;
	constructor(
    private router: Router, 
    private networkingService: NetworkingService,
    private loaderService: LoaderService   ,
    @Inject(SESSION_STORAGE) private storage: WebStorageService
  ) { 
    this.navMenu = true;
    this.showAgencyInformation = false;
    this.currentPageName ="Login";
    this.publishCurrentPage(this.currentPageName);
  }
  
  ngOnInit() {
    this.agencyInfo = this.storage.get("agencyInfo");
    this.agentInfo = this.storage.get("agentInfo");
  }

  getDeviceType() {
    return (window.innerWidth >= 768) ? true : false;
  }

  publishCurrentPage(value : string) {
    this.currentPageSubject.next(value);
  }

  authenticateUser(username, password) : Observable<any> {
    this.userDetails = {
      "rememberUser": true,
      "userName": username,
      "password": password
    }
    return this.networkingService.post('/account/authenticate', (username && password)?this.userDetails:null)
    .map(
      response => {
        this.setAuthToken(response.token);
        this.isloggedIn = true;
        this.setUserRole(this.manageUserRoles(response));
        this.setAgencyDetails(response);
        this.setSessionValuesOnLogin();
        
        this.getCityList(response.country)
        .subscribe((response) => {
          this.storage.set('cityStoredObj', JSON.stringify(response));
        });
        response.redirectUrl = this.redirectUrl;
        return response;
      },
      error => error
    );
  }
  signOut() : Observable<any> {
    return this.networkingService.get('/account/signout')
    .map(
      response => {

        return response;
      },
      error => error
    );
  }
  getCityListData(){
    return this.storage.get('cityStoredObj');
  }
  setSessionValuesOnLogin(){
    this.storage.set("authToken", this.authenticationToken);
    this.storage.set("userRole", this.userRole);
    this.storage.set("agencyDetails", this.agencyDetails);
    this.networkingService.setAuthToken(this.authenticationToken);
  }
  restoreSession(){
    this.authenticationToken = this.storage.get("authToken");
    this.userRole = this.storage.get("userRole");
    this.agencyDetails = this.storage.get("agencyDetails");
    this.agencyInfo = this.storage.get("agencyInfo");
    this.agentInfo = this.storage.get("agentInfo");
    this.hasModify = this.storage.get("hasModify");
    this.networkingService.setAuthToken(this.authenticationToken);
  }
  clearSession(){
    this.storage.remove('authToken');
    this.storage.remove('userRole');
    this.storage.remove('agencyDetails');
    this.storage.remove("agencyInfo");
    this.storage.remove("agentInfo");
    this.storage.remove("hasModify");
    this.storage.remove("cityStoredObj");
    this.networkingService.setAuthToken(undefined);
  }
  setAuthToken(token) {
      this.authenticationToken = token;
  }
  getAuthToken(){ 
      return this.authenticationToken;
  }
  setUserRole(role){
      this.userRole = role;
  }
  getUserRole(){
      return this.userRole;
  }
  isUserLoggedIn(): boolean {
    if(this.getAuthToken()){
      return true;
    }
    if(this.storage.get('authToken')){
      this.restoreSession();
      return true;
    }
    return false;
  }
  getHasModify() {
    return this.storage.get("hasModify");
  }
  setAgencyDetails(agency) {
    this.agencyDetails = agency;
  }

  getAgencyDetails() {
    return this.agencyDetails;
  }
  manageUserRoles(loginData) : string {    
    let role = '';
    for(let i=0; i<loginData.userGroups.length; i++) {
      if(loginData.userGroups[i].groupName == 'TA_ACCMANAGE') {
        if(loginData.isChildAgency) {
          role = 'TA_ACCMANAGE_child';
          this.redirectUrl = '/dashboard';
        } else {
          role = 'TA_ACCMANAGE_parent';
          this.redirectUrl = '/dashboard';
        }
        break;
      }//  else if(loginData.userGroups[i].groupName == 'TA_ADMIN') {
      //   role = 'TA_ADMIN';
      //   this.redirectUrl = '/reports/balance';
      //   break;
      // } else if(loginData.userGroups[i].groupName == 'TRAVEL_AGENT') {
      //   role = 'TRAVEL_AGENT';
      //   this.redirectUrl = '/reports/balance';
      //   break;
      // }
      else{
        role = 'unAuthorized';
      }
    }
    return role;
  }

  // getLoginUrl(): string {
  //   return this.loginUrl;
  // }

  getAgencyList(param: string) : Observable<any> {
    let agencyListArray : Array <AgencyList> =  [];
    let queryString = '';
    if(param == 'combo'){
      queryString = '?param='+param;
    }
    return this.networkingService.get('/agency/agency-list'+queryString)
    //return this.networkingService.get('../../assets/json/agencyList.json')
    .map(
      response => {
        agencyListArray = this.processAgencyListArray(response.result.viewAgencyInfos);
        this.hasModify = response.result.hasModify;
        this.storage.set("hasModify", response.result.hasModify);
        this.hasTopup = response.result.hasTopup;
        return agencyListArray;
      },
      error => error
    );
  }

  processAgencyListArray(agencyListArray) : Array <AgencyList> {
    let agencyList = [];
    for(let i=0; i<agencyListArray.length; i++) {
      let agentObj = agencyListArray[i];
      let agentModel = new AgencyList(agentObj);
      agencyList.push(agentModel);
    }
    return agencyList;
  }

  getAgencyInfo(iatacode) : Observable<any> {    
    return this.networkingService.get('/agency/agency-info?iatacode='+iatacode)
    .map(
      response => {
        this.loaderService.hide();
        return new AgencyInfo(response.result);
      },
      error => error
    );
  }

  getAgentInfo(userid, iataNumber) : Observable<any> {
    return this.networkingService.get('/agent/agent-info?userid='+userid+"&iataNumber="+iataNumber)
    .map(
      response => {
        console.log(response.result);
        return new AgentInfo(response.result);
      },
      error => error
    );
  }

  getAgentList(iatacode) : Observable<any> {    
    return this.networkingService.get('/agent/agent-list?iataNumber='+iatacode)
    .map(
      response => {
        return this.processAgentListArray(response.result.viewAgents);
      },
      error => error
    );
  }
  processAgentListArray(agentListArray) : Array <AgentList> {
    let agentList = [];
    for(let i=0; i<agentListArray.length; i++) {
      let agentObj = agentListArray[i];
      let agentModel = new AgentList(agentObj);
      agentList.push(agentModel);
    }    
    return agentList;
  }

  publishAgentList(agentList : AgencyInfo){
    this.agentListSubject.next(agentList);
  }

	getAgencyInfoDetails() {
		return this.agencyInfo;
	}
	setAgencyInfoDetails(agencyInfo, iatacode) {
    agencyInfo.iatacode = iatacode;
    this.agencyInfo = agencyInfo;
    this.storage.set("agencyInfo", this.agencyInfo);
    this.publishAgentList(this.agencyInfo);
	}

  editAgency(agency,agencyInfo) {  
    this.showMultiLoader(); 
    this.getAvailableCredit(agency.iatacode).subscribe((creditResponse) => {
      this.getAgencyInfo(agency.iatacode).subscribe((response) => {
        response.creditLimit=creditResponse.availableCredit;
        response.actualCreditLimit=creditResponse.creditLimit;
        response.modifyFlag=agency.modifyFlag;
        this.setAgencyInfoDetails(response, agency.iatacode);
        this.router.navigate(['/create', 'modifyAgency']);
      });  
    });  
  }

  editAgent(agent) {
    this.getAgentInfo(agent.userId, agent.iataCode).subscribe((response) => {
      response.iataCode = agent.iataCode;
      response.modifyFlag=agent.modifyFlag;
      this.setAgentInfoDetails(response);
      this.router.navigate(['/create', 'modifyAgent']);
    });
  }

  getAgentInfoDetails() {
    return this.agentInfo;
  }
  setAgentInfoDetails(agentInfo) {
    this.agentInfo = agentInfo;
    this.storage.set("agentInfo", this.agentInfo);
  }

  doTopUp(agency) {   
                          debugger;
    this.getAvailableCredit(agency.iatacode).subscribe((creditResponse) => {
      this.getAgencyInfo(agency.iatacode).subscribe((response) => {
        response.creditLimit=creditResponse.availableCredit;
        response.actualCreditLimit=creditResponse.creditLimit;
        this.setAgencyInfoDetails(response, agency.iatacode);    

        this.router.navigate(['topUp']);
      });
    });
    
  }

  getReportsMenu() : Observable<any> {
    return this.networkingService.getJSON('../../assets/json/reportsMenu.json')
    .map(
      response => {
        return response;
      },
      error => error
    );
  }

  getCityList(countryCode) : Observable<any> {
    /*return this.networkingService.getJSON('../../assets/json/citylist.json')
    .map(
      response => {
        return response;
      },
      error => error*/
  
    return this.networkingService.get('/master/cities')
    .map(
      response => {
        return this.processCityListArray(response.result.cities,countryCode);
      },
      error => error
    );


  }
  processCityListArray(cityListArray,countryCode) : Array <any> {
    let cityList = [];
    for(let i=0; i<cityListArray.length; i++) {
      let cityApiObj = cityListArray[i];
      if (cityApiObj.country.code==countryCode){
        let cityObj={"key":cityApiObj.code,"value":cityApiObj.name}
        cityList.push(cityObj);
      }   
    }    
    return cityList;
  }
  getCountryList() : Observable<any> {
    return this.networkingService.getJSON('../../assets/json/countrylist.json')
    .map(
      response => {
        return response;
      },
      error => error
    );
  }

  getAvailableCredit(iatacode) : Observable<any> {    
    return this.networkingService.get('/agency/available-credit?iatacode='+iatacode)
    .map(
      response => {
        return response.result;
      },
      error => error
    );
  }

  sendPwd(agent){
    return this.networkingService.post('/account/send-password', { "userName": agent.userId, "email": agent.emailId })
    .map(
      response => {
        return response;
      },
      error => { error;
      });

  }

  showMultiLoader(){
    this.networkingService.showMultiLoader();
  }
  hideMultiLoader(){
    this.networkingService.hideMultiLoader();
  }

  public sessionExpireyRedirection(){
        this.router.navigate(['/externalRedirect', { externalUrl: environment.taPortal }]);
  }
  
  //to check whether agency current listed under 3 decimal point currency list
  isThreeDecimalPlaces() {
    let details = this.getAgencyInfoDetails();
    if (details) {
      let currency: any = details.currencyCode;
      return ThreeDecimalCurrencies.indexOf(currency) >= 0;
    }
    return false;
  }
}


// WEBPACK FOOTER //
// C:/Agent0/_work/434/s/src/app/shared/shared.service.ts